/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerFeedMill } from '../../models/customer-feed-mill';
import { CustomerFeedMillCreateDto } from '../../models/customer-feed-mill-create-dto';

export interface AddCustomerFeedMill$Params {
      body: CustomerFeedMillCreateDto
}

export function addCustomerFeedMill(http: HttpClient, rootUrl: string, params: AddCustomerFeedMill$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerFeedMill>> {
  const rb = new RequestBuilder(rootUrl, addCustomerFeedMill.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerFeedMill>;
    })
  );
}

addCustomerFeedMill.PATH = '/api/customer/feedMill';
